import { render, staticRenderFns } from "./Sidebar-Group.vue?vue&type=template&id=f51b07c6"
import script from "./Sidebar-Group.vue?vue&type=script&lang=js"
export * from "./Sidebar-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports